import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './CustomTrainingTable.css';

const CustomTrainingTable = ({ courses }) => {
  if (!courses || courses.length === 0) {
    return null;
  }

  const getStatusBadge = (status) => {
    const statusLower = (status || 'not_started').toLowerCase();

    if (statusLower === 'completed' || statusLower === 'approved') {
      return <span className="badge bg-success"><i className="bx bx-check-circle me-1"></i>Completed</span>;
    } else if (statusLower === 'in_progress') {
      return <span className="badge bg-primary"><i className="bx bx-time me-1"></i>In Progress</span>;
    } else {
      return <span className="badge bg-secondary"><i className="bx bx-circle me-1"></i>Not Started</span>;
    }
  };

  const handleViewPDF = (course) => {
    // Extract course ID from courseKey (format: "custom-training-{id}")
    const courseId = course.courseKey.replace('custom-training-', '');
    window.location.href = `/custom-training/pdf/${courseId}`;
  };

  // A course built from a PDF is taken module by module in the player, with its
  // own gated quiz per module — there is no document to read and no single
  // end-of-course quiz. Older courses keep the PDF-then-quiz pair.
  const handleLaunch = (course) => {
    const courseId = course.courseKey.replace('custom-training-', '');
    window.location.href = `/custom-training/course/${courseId}`;
  };

  const handleTakeQuiz = (course) => {
    // Extract course ID from courseKey (format: "custom-training-{id}")
    const courseId = course.courseKey.replace('custom-training-', '');
    window.location.href = `/custom-training/quiz/${courseId}`;
  };

  return (
    <div className="custom-training-table-container">
      <div className="table-responsive">
        <table className="table table-hover custom-training-table">
          <thead>
            <tr>
              <th>Course Name</th>
              <th>Description</th>
              <th className="text-center">Hours</th>
              <th className="text-center">Status</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {courses.map((course, index) => (
              <tr key={course.id || index}>
                <td>
                  <strong>{course.courseTitle || 'Untitled Course'}</strong>
                </td>
                <td>
                  <span className="text-muted">
                    {course.description || 'No description available'}
                  </span>
                </td>
                <td className="text-center">
                  {course.hours || '-'}
                </td>
                <td className="text-center">
                  {getStatusBadge(course.status)}
                </td>
                <td className="text-center">
                  <div className="btn-group" role="group">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => (course.isModular ? handleLaunch(course) : handleViewPDF(course))}
                      title={course.isModular ? 'Work through the course module by module' : 'View Course Material'}
                    >
                      <i className={`bx ${course.isModular ? 'bx-play-circle' : 'bx-file-blank'} me-1`}></i>
                      {course.isModular ? 'Launch Course' : 'View PDF'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success"
                      onClick={() => handleTakeQuiz(course)}
                      title="Take Quiz"
                      hidden={course.isModular}
                      style={course.isModular ? { display: 'none' } : undefined}
                    >
                      <i className="bx bx-edit me-1"></i>
                      Take Quiz
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

CustomTrainingTable.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.shape({
    isModular: PropTypes.bool,
    id: PropTypes.string,
    courseTitle: PropTypes.string,
    description: PropTypes.string,
    hours: PropTypes.number,
    status: PropTypes.string
  }))
};

CustomTrainingTable.defaultProps = {
  courses: []
};

export default CustomTrainingTable;
